(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('rare-is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.04 }
  );

  const observeSections = (root = document) => {
    const viewport = window.innerHeight;
    root.querySelectorAll('main .shopify-section:not(.rare-reveal-bound)').forEach((section) => {
      section.classList.add('rare-reveal-bound');
      // Content already on screen at load shows instantly — only content below the fold animates in.
      if (section.getBoundingClientRect().top < viewport * 0.92) {
        section.classList.add('rare-is-visible', 'rare-instant');
        return;
      }
      observer.observe(section);
    });
  };

  const start = () => {
    observeSections();
    document.documentElement.classList.add('rare-reveal-ready');

    // Safety net: never leave a section hidden if the observer misses it (e.g. restored scroll position).
    window.setTimeout(() => {
      document.querySelectorAll('main .shopify-section:not(.rare-is-visible)').forEach((section) => {
        if (section.getBoundingClientRect().top < window.innerHeight) section.classList.add('rare-is-visible');
      });
    }, 1200);

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', (event) => observeSections(event.target));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
